module.exports = __webpack_public_path__ + "static/media/ill-start-by-opening-p1.3bd788f3.jpg";